import { ShieldCheck, Truck, RotateCcw } from "lucide-react";

const ITEMS = [
  { Icon: ShieldCheck, label: "Paiement sécurisé Stripe", testid: "trust-payment" },
  { Icon: Truck, label: "Expédition suivie", testid: "trust-shipping" },
  { Icon: RotateCcw, label: "Retours sous 14 jours", testid: "trust-returns" },
];

export default function TrustBadges() {
  return (
    <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2" data-testid="trust-badges">
      {ITEMS.map(({ Icon, label, testid }) => (
        <span key={testid} data-testid={testid} className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-slate-400">
          <Icon className="h-4 w-4 text-emerald-400" /> {label}
        </span>
      ))}
    </div>
  );
}
